
import { ResponseType } from "../../../Types/ServicesType/servicesType";
import { SearchParamsType } from "../../CinicManagement/types";
import { UserListType } from "./types";
import api from "@services/apiList";
import instance from "@services/services";

const {SettingsApi} = api
export const getAllLog = async (params:SearchParamsType):Promise<ResponseType<{items:UserListType[],totalcount:number}>>=>{
    const result = await instance.post(`${SettingsApi.getLogHistory}`,params);
    return result.data;
}



